module.exports = __webpack_public_path__ + "static/img/SI-Gray.a10ff3e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/SI-Gray.png
// module id = 5hB6
// module chunks = 1